import { Link, Typography } from "@material-ui/core";
import React from "react";

const BadRequest = () => {
  return (
    <div className="error-page">
      <img src={`${process.env.PUBLIC_URL}/assets/images/loading-logo.png`} alt="logo" />
      <div className="title">
        <Typography className="text" component="span">
          Hemos detectado un problema.
        </Typography>
        <span className="emoji" role="img" aria-label="emoticon">
          😰
        </span>
      </div>
      <Typography className="subtitle" align="center" gutterBottom>
        Posibles causas:
      </Typography>

      <Typography className="options" align="center" gutterBottom>
        - Revisa si tu equipo tiene la hora/zona horaria configurada correctamente.
      </Typography>

      <Typography className="mail" align="center" gutterBottom>
        Favor escríbenos a <Link href="mailto:hola@carritofacil.cl">hola@carritofacil.cl</Link>
      </Typography>
    </div>
  );
};

export default BadRequest;
